module.exports = __webpack_public_path__ + "img/payment_icon_gpwebpay.53277441.png";